module.exports = __webpack_public_path__ + "img/vat_calculation.8c4eb9ef.png";